import { Grid } from "@mui/material";
import MxFormL3SelectTrustField from "@rf-l3/form/MxFormL3SelectTrustField";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import { useFormValidationsDocumentsMsgSlice } from "../../../../../../../store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const IsPending = () => {
  const {
    validationDocuments: { land_transfer_tax }
  } = useFormValidationsDocumentsMsgSlice();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container columnGap={1}>
      <Grid
        container
        item
        xs={4}
        rowGap={2}
        justifyContent="center"
        alignSelf="flex-start"
      >
        <Grid item xs={12}>
          <MxFormL3SelectTrustField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_name_trustee}
            label="Nombre de fiduciaria"
          />
        </Grid>
        <Grid item xs={12}>
          <MxFormL3InputField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_name_official_trustee}
            label="Nombre de ejecutivo"
          />
        </Grid>
        <Grid item xs={12}>
          <MxFormL3InputField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_email_trustee}
            label="Correo de fiduciaria"
          />
        </Grid>
        <Grid item xs={12}>
          <MxFormL3TextDateField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_estimated_constitution_date}
            label="Fecha estimada de constitución de fideicomiso"
          />
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_tax_receipt}
          label="Comprobante impuesto"
          maxSize={3}
          minSize={0}
          disabled={land_transfer_tax?.disabled}
          typeKey={CValidationDocumentKeys.LandTransferTax}
        />
        <MxTypography variant="caption" color="grey.400" my={0.5}>
          Comprobante de impuesto de transferencia de terreno
        </MxTypography>
      </Grid>
    </Grid>
  );
};

export default IsPending;
